import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HotelList from '../components/views/hotels/HotelList';
import { ResponseFailModal } from '../components/modal/Response';
import Spin from '../components/Spin';
import {
  hotelListAction,
  headerAction,
  sidebarAction,
  buildingListAction,
  roomListAction,
  doorlockListAction,
  bookingListAction,
  staffListAction,
  reportListAction,
} from '../stores/actions';
import * as api from '../api';
import useDebounce from '../lib/useDebounce';

const HotelListContainer = ({history}) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isOpenApiErrorModal, setIsOpenApiErrorModal ] = useState(false);
  const [ isDebounce, setIsDebounce ] = useState(false); //디바운싱 사용 구분을 위해 추가
  const [ apiErrorMessage, setApiErrorMessage ] = useState('');
  const [ apiErrorSubMessage, setApiErrorSubMessage ] = useState('');
  const [ paginationItem, setPaginationItem ] = useState({
    offset: 0,
    limit: 3,
  });
  const [ filterItem, setFilterItem ] = useState({
    name: '',
  });
  const { hotelListTotal, hotelListItems } = useSelector(state => state.hotelList);
  const dispatch = useDispatch();

  const listHotel = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await api.listHotel({...filterItem, ...paginationItem});
      dispatch(hotelListAction.setHotelList(res.data));
    } catch (error) {
      setApiErrorMessage('호텔 목록 조회 실패');
      if (!error.response) setApiErrorSubMessage(error.message);
      else setApiErrorSubMessage(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenApiErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, filterItem, paginationItem]);

  const selectedHotel = async (hotelId) => {
    try {
      localStorage.setItem('hotel_id', hotelId);
      const hotel = await api.selectHotel();
      dispatch(headerAction.setHeaderItem({
        role: hotel.data.role,
      }));
      dispatch(sidebarAction.setSidebarItem({
        hotelName: hotel.data.name,
        timezone: hotel.data.timezone,
        address: hotel.data.address,
        buildingCount: hotel.data.building_counts,
        roomCount: hotel.data.room_counts,
        pincodeVersion: hotel.data.pincode_version,
        doorlockDeletable: hotel.data.doorlock_deletable,
      }));
    } catch (error) {
      setApiErrorMessage('호텔 선택 실패');
      if (!error.response) setApiErrorSubMessage(error.message);
      else setApiErrorSubMessage(`${error.response.data.code}, ${error.response.data.message}`);
      setIsOpenApiErrorModal(true);
      throw error;
    }
  };

  const initHotel = useCallback(() => {
    localStorage.removeItem('hotel_id');
    dispatch(headerAction.setHeaderItem({
      role: '',
    }));
    dispatch(sidebarAction.setSidebarItem({
      hotelName: '',
      timezone: '',
      address: '',
      buildingCount: '',
      roomCount: '',
      pincodeVersion:'',
      doorlockDeletable: false,
    }));
  }, [dispatch]);

  //디바운싱 훅으로 이동
  const handleDebounce = useCallback(
    useDebounce((listFloor) => listFloor(), 300) //0.3초 동안 미입력 시 함수 실행
  ,[]);

  //최초 인마운트 시 목록 불러오기

  useEffect(() => {
    try {
      dispatch(buildingListAction.initBuildingListState());
      dispatch(roomListAction.initRoomListState());
      dispatch(doorlockListAction.initDoorlockListState());
      dispatch(bookingListAction.initBookingListState());
      dispatch(staffListAction.initStaffListState());
      dispatch(reportListAction.initReportListState());
      if (localStorage.getItem('hotel_id')) initHotel();
      !isDebounce? listHotel() : handleDebounce(listHotel); //디바운싱 처리
    } catch (error) {
      throw error;
    }
  }, [dispatch, initHotel, listHotel, handleDebounce, isDebounce, filterItem]);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <Header history={history} />
      <div className='content-wrap'>
        <div className='content-card'>
          <HotelList
            hotelListTotal={hotelListTotal}
            hotelListItems={hotelListItems}
            filterItem={filterItem}
            paginationItem={paginationItem}
            listHotelApi={listHotel}
            selectedHotel={selectedHotel}
            setFilterItem={setFilterItem}
            setPaginationItem={setPaginationItem}
            setIsDebounce={setIsDebounce}
            history={history}
          />
          <ResponseFailModal
            isOpen={isOpenApiErrorModal}
            toggle={() => setIsOpenApiErrorModal(!isOpenApiErrorModal)}
            message={apiErrorMessage}
            subMessage={apiErrorSubMessage}
          />
        </div>
      </div>
      <Footer />
    </Fragment>
  );
}

export default HotelListContainer;